module.exports = __webpack_public_path__ + "static/media/close.ef050a75.svg";